// Use PostgreSQL query (not AWS Amplify query)
import {listItems as listItemsGraphQL} from '../../../graphql/queries';
import {queryGqlApi} from "../../../graphql/queryGqlApi";
import { IDataClientService } from '../../../platform/services/data/DataClientService';
import { IAuthService } from '../../../platform/services/auth/AuthService';


export const listItems = (
    dataClientService: IDataClientService,
    authService: IAuthService,
    workspaceId: string, 
    nextToken?: string, 
    limit?: number
): Promise<any> => {
    return queryGqlApi(
        listItemsGraphQL,
        {
            id: workspaceId,
            limit: limit,
            nextToken: nextToken
        },
        dataClientService,
        authService,
        'pgServer'
    );
}
